import { useCallback } from "react";
import { sendGAEvent } from "@next/third-parties/google";
import posthog from "posthog-js";
import { trackMetaPixelEvent } from "../meta-pixel";

const useAnalytics = (channels = ["Google", "Posthog"]) => {
  const track = useCallback(
    (eventName: string, properties: any = {}) => {
      if (channels.includes("Google")) {
        sendGAEvent("event", eventName, properties);
      }
      if (channels.includes("Posthog")) {
        posthog.capture(eventName, properties);
      }
      if (channels.includes("Meta")) {
        trackMetaPixelEvent(eventName);
      }
    },
    [channels]
  );

  return track;
};

export default useAnalytics;
